/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit StatusName/view.blocks to change it.
import * as fromAggregate from 'Simple/Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import LongArrowRight from 'DesignSystem/Svgs/LongArrowRight/index'
import React from 'react'
import TysiaTag from 'DesignSystem/TysiaTag/index'
import TysiaTagText from 'DesignSystem/TysiaTag/TysiaTagText/index'
import useIsMedia from 'Simple/hooks/useIsMedia'



/** @type {import('Simple/types.js').View} */
export default function StatusName({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/EventsTimeline/Content/Event/Types/Status/Content/Content/StatusName"
  
}) {
  let isMedia = useIsMedia()
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
let statusNameValueData = fromData.useDataFormat({ viewPath,
context: 'status',
path: 'name',
format: fromFormat.statusActionName,
})
let aggregateData = fromAggregate.join(statusNameValueData)
  return (<React.Fragment
>
<TysiaTag
  viewPath={`${viewPath}/TysiaTag`}
 type="grey"
 style="outline"
 size={isMedia.mobile ? "small" : "medium"}
>
{childProps => (
<React.Fragment>
<TysiaTagText
{...childProps}
  viewPath={`${viewPath}/TysiaTagText`}
 text="Status"
/>
<LongArrowRight
{...childProps}
  viewPath={`${viewPath}/LongArrowRight`}
 stroke={dtColorsNeutral600}
 marginLeft={2}
 marginRight={2}
 width={16}
 height={16}
/>
<TysiaTagText
{...childProps}
  viewPath={`${viewPath}/TysiaTagText`}
 data="status.name"
 format="/Data/format.js statusActionName"
 aggregate="/Simple/Data/aggregate.js join"
 text={aggregateData}
/>
</React.Fragment>
)}
</TysiaTag>
{children}
</React.Fragment>)
}